import { FlexTimePeriod, Registration, SectionType, StudentSection } from 'libs/domain';

export const flexToStudentSection = (r: Registration): StudentSection => {
  return {
    id: r.registration?.flexTimeActivity.id,
    name: r.registration?.flexTimeActivity.name,
    period: r.registration?.flexTimePeriod?.title,
    term: '',
    date: r.registration?.flexTimePeriod.date,
    startTime: r.registration?.flexTimePeriod.startTime,
    endTime: r.registration?.flexTimePeriod.endTime,
    teachers: [r.registration?.flexTimeActivity?.createdByPerson?.name],
    location: r.registration?.flexTimeActivity.location,
    showProfilePicture: r.registration?.flexTimeActivity?.showStudentPhotoOnCheckin,
    checkinReasonId: r.registration.checkinReasonId,
    type: SectionType.FLEX,
  };
};

// teachers will never have more than one activity instance in a flextime period
export const flexPeriodToStudentSection = (p: FlexTimePeriod): StudentSection => {
  return {
    id: p.activityInstances[0]?.id,
    name: p.activityInstances[0]?.flexTimeActivity?.name ?? '',
    period: p.title,
    term: '',
    date: p.date,
    startTime: p.startTime,
    endTime: p.endTime,
    teachers: [],
    location: p.activityInstances[0]?.flexTimeActivity?.location,
    showProfilePicture: p.activityInstances[0]?.flexTimeActivity?.showStudentPhotoOnCheckin,
    checkinReasonId: p.activityInstances[0]?.checkinReasonId,
    type: SectionType.FLEX,
  };
};
